module.exports = __webpack_public_path__ + "img/bb_g3_head-01.62656747.svg";